import emeraldBingHybridStyle from "@/assets/map-styles/emerald-bing-hybrid.json";
import { bingKey } from "@/constants";
import { useEffect, useState } from "react";

interface BingImageryResponse {
  resourceSets: Array<{
    resources: Array<{
      imageUrl: string;
    }>;
  }>;
}

// Custom fetch-based hook to replace RTK Query
export const useGetEmeraldBingTilesQuery = () => {
  const [data, setData] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let isCancelled = false;

    const fetchBingTiles = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        setError(null);

        const response = await fetch(
          `https://dev.virtualearth.net/REST/V1/Imagery/Metadata/Aerial?output=json&include=ImageryProviders&key=${bingKey}`,
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const bingResponse: BingImageryResponse = await response.json();

        if (!isCancelled) {
          const tiles = bingResponse.resourceSets[0].resources[0].imageUrl
            .replace("{subdomain}", "t0")
            .replace("http://", "https://");

          const transformedData = {
            ...emeraldBingHybridStyle,
            sources: {
              ...emeraldBingHybridStyle.sources,
              "bing-tiles": {
                ...emeraldBingHybridStyle.sources["bing-tiles"],
                tiles: [tiles],
              },
            },
          };

          setData(transformedData);
        }
      } catch (err) {
        if (!isCancelled) {
          setIsError(true);
          setError(
            err instanceof Error ? err : new Error("Unknown error occurred"),
          );
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchBingTiles();

    return () => {
      isCancelled = true;
    };
  }, []);

  return {
    data,
    isLoading,
    isError,
    error,
  };
};
